import { Skeleton } from "@/v2/components/ui/skeleton";
import { LIVE_CHANNEL_IDS } from "@/v2/lib/liveChannels";
import { useMediaQuery } from "@/v2/hooks/useMediaQuery";

const HEADER_HEIGHT = 58;
const ROW_HEIGHT = 96;
const LABEL_WIDTH = 152;
/** See TimelineGrid's LABEL_WIDTH_COMPACT: matches the real grid's icon-only
 * collapse below sm, so the skeleton's label column doesn't jump once the
 * real grid replaces it. */
const LABEL_WIDTH_COMPACT = 64;

/** Placeholder blocks per row, varied so the row doesn't read as one flat bar. */
const ROW_BLOCK_WIDTHS = [
  ["18%", "26%", "14%", "30%"],
  ["30%", "20%", "22%"],
  ["14%", "34%", "18%", "20%"],
];

/**
 * Stands in for TimelineGrid/WeekGrid while channels and the day's schedule
 * are still loading, at the same row/label dimensions, so the grid doesn't
 * pop from a blank box to full content in one frame.
 */
export function SchedulerGridSkeleton() {
  const compact = useMediaQuery("(max-width: 639px)");
  const labelWidth = compact ? LABEL_WIDTH_COMPACT : LABEL_WIDTH;
  return (
    <div aria-hidden data-testid="scheduler-grid-skeleton">
      <div className="flex border-b border-border" style={{ height: HEADER_HEIGHT }}>
        <div className="shrink-0" style={{ width: labelWidth }} />
        <div className="flex flex-1 items-center" style={{ gap: 24, padding: "0 16px" }}>
          {Array.from({ length: 6 }, (_, i) => (
            <Skeleton key={i} className="v2-skeleton-wave h-3 w-10 rounded" />
          ))}
        </div>
      </div>

      {LIVE_CHANNEL_IDS.map((id, row) => (
        <div
          key={id}
          className="flex items-center border-b border-border last:border-b-0"
          style={{ height: ROW_HEIGHT }}
        >
          <div
            className="flex shrink-0 items-center"
            style={{ width: labelWidth, gap: 10, padding: compact ? "0 10px" : "0 16px" }}
          >
            <Skeleton className="v2-skeleton-wave h-9 w-9 shrink-0 rounded-full" />
            {compact ? null : <Skeleton className="v2-skeleton-wave h-3 w-16 rounded" />}
          </div>
          <div className="flex flex-1 items-center" style={{ gap: 12, padding: "0 16px" }}>
            {ROW_BLOCK_WIDTHS[row % ROW_BLOCK_WIDTHS.length].map((width, i) => (
              <Skeleton
                key={i}
                className="v2-skeleton-wave rounded-md"
                style={{ height: ROW_HEIGHT - 32, width }}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
